import React from 'react'
import { Modal, Form, Input, Button, Space, App } from 'antd';
import { useDept_delMutation } from '../../store/ReactWebSiteApi';
function DeptDel(props) {
    const { message } = App.useApp();
    const {confirm} = Modal; 
    const [submitDel] = useDept_delMutation()   
    return (
        <>
            {props.ed_state==='2' && <a onClick={() => {
                    confirm({
                        title: '确定删除吗？',
                        content: props.ed_name,
                        okText: '确认',
                        okType: 'danger',
                        cancelText: '取消',
                        onOk() {
                            submitDel({
                                ed_id:props.ed_id,
                                ed_state:'2',
                            }).then((res) => {
                                if (res.data.Status === 'success') {
                                    message.success('删除部门成功！')
                                    // setSelectedDept([res.data.Result.ed_parent_id])
                                    // setAddDeptData(prevState => ({ ...prevState, ed_parent_id: res.data.Result.ed_parent_id }));
                                    // setEditDeptId(+res.data.Result.ed_parent_id);
                                    // refetch();
                                    }
                                    if (res.data.Status === 'fail') {
                                    message.error('删除部门失败！' + res.data.Message)
                                    }
                            })
                        },
                        onCancel() {
                        console.log('Cancel');
                        },
                    })
                }} 
            >删除</a>}
            {props.ed_state==='1'&&<a onClick={() => {
                    confirm({
                        title: '确定取消删除吗？',
                        content: props.ed_name,
                        okText: '确认',
                        okType: 'danger',
                        cancelText: '取消',
                        onOk() {
                            submitDel({
                                ed_id:props.ed_id,
                                ed_state:'1',
                            }).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.info('取消删除成功！');
                                }
                                if (res.data.Status === "fail") {
                                    message.error('取消删除失败！'+res.data.Message)
                                }
                            })
                        },
                        onCancel() {
                        console.log('Cancel');
                        },
                    });
                }}>取消删除</a>}
        </>
    )
}

export default DeptDel